








































































































































































































































































































































































































































































































































import { Component, Watch, Mixins } from 'vue-property-decorator';
import { KunshanApplicationController, DropDownController } from '@/services/request.service';
import LocationCascader from '@/components/LocationCascader.vue';
import FormStep1 from '@/components/mixins/FormStep1';
import SiblingInfo from './SiblingInfo.vue';
import moment, { Moment } from 'moment';
import fields from '@/fields.config';
import utils from '../utils';
import { debounce } from '@/utils/utils';
@Component({
  components: {
    SiblingInfo,
    LocationCascader,
  },
})
export default class Step1 extends Mixins(FormStep1) {
  public fields = fields;
  public studentId: any = '';
  public draftId: any = '';
  public dataSource: any = [];
  public isSource: boolean = false;
  public sourceExtra: any = '';
  public sourceExtraId: any = '';
  public isName: boolean = false;
  public searchText: any = '';
  public changeDebounce = debounce(this.getAutoList);
  public get fieldsType() {
    return this.school === 'kcscd' ? 'kcscd' : 'default';
  }
  // public created() {
  //   const isDraft = this.$route.query.isDraft;
  //   if (isDraft) {
  //     this.getDraft();
  //   } else {
  //     this.getEnquiry();
  //   }
  // }
  public handleSourceChange(value: number): void {
    this.$nextTick(() => {
      this.applicationStep1Form.setFieldsValue({
        sourceExtra: '',
      });
    });
    this.sourceId = value;
    this.sourceIsOther = this.config[this.school].showResourceExtraValue.includes(value) ? true : false;
    if (this.school === 'ks') {
      this.teacherSource = value === 1280 ? true : false;
      this.studentSource = value === 741 ? true : false;
    } else if (this.school === 'ts') {
      this.teacherSource = value === 1326 ? true : false;
      this.studentSource = value === 1325 ? true : false;
    } else {
      this.teacherSource = value === 637 ? true : false;
      this.studentSource = value === 1273 ? true : false;
    }
    this.dataSource = [];
  }
  public onSourceSelect(value: any, option: any) {
    this.sourceExtraId = Number(value);
    this.dataSource.map((item: any) => {
      if (item.key === this.sourceExtraId) {
        this.sourceExtra = item.value;
      }
    });
    this.$nextTick(() => {
      this.applicationStep1Form.setFieldsValue({
        sourceExtra: this.sourceExtra,
      });
    });
  }
  public getAutoList() {
    if (this.studentSource === true) {
      DropDownController.getStudentsByName(this.searchText).then(res => {
        if (res) {
          this.dataSource = [];
          res.data.map(item => {
            if (item.enValue) {
              this.dataSource.push({
                // vaule: item.value + item.enValue,
                // key: item.key,
                value: item.value + item.enValue,
                key: item.key,
              });
            } else {
              this.dataSource.push({ value: item.value, key: item.key });
            }
          });
        }
      });
    }
    if (this.teacherSource === true) {
      DropDownController.getMembersByName(this.searchText).then(res => {
        //   this.data = res && res.data ? res.data : {};
        // for (var i in this.data) {
        //   this.studentList.push(this.data[i].name);
        // }
        if (res) {
          this.dataSource = [];
          res.data.map(item => {
            if (item.enValue) {
              this.dataSource.push({
                // vaule: item.value + item.enValue,
                // key: item.key,
                value: item.value + item.enValue,
                key: item.key,
              });
            } else {
              this.dataSource.push({ value: item.value, key: item.key });
            }
          });
        }
        // this.dataSource = res.data
      });
    }
  }
  public ontabChange() {}
  public nameChange() {
    const value = this.applicationStep1Form.getFieldsValue().name;
    if (value) {
      this.isName = true;
      setTimeout(() => {
        const name = this.applicationStep1Form.getFieldsValue().name.replace(/[ ]/g, '');
        const reg = new RegExp('[\\u4E00-\\u9FFF]+$', 'g');
        // const name = value.replace(/[ ]/g, '');
        if (name.length >= 2 && reg.test(value)) {
          this.nameConvertSpell(name);
        }
      }, 200);
    }
    if (!value) {
      this.applicationStep1Form.setFieldsValue({
        pinyinLastName: '',
        pinyinFirstName: '',
      });
      this.isName = false;
    }
  }
  public nameConvertSpell(value: any) {
    KunshanApplicationController.nameConvertSpell(value).then(res => {
      this.applicationStep1Form.setFieldsValue({
        pinyinLastName: res.data.surname,
        pinyinFirstName: res.data.moniker,
      });
    });
  }
  public onSearch(searchText: any) {
    if (searchText) {
      this.searchText = searchText.trim();
      this.changeDebounce();
    }
  }
  public get rules() {
    return {
      name: {
        validateTrigger: 'blur',
        rules: [
          {
            max: 50,
            pattern: /^[\u4E00-\u9FA5]{1,50}$/,
            min: 1,
            whitespace: true,
            message: this.$t('warningTip.nameInvaild'),
          },
        ],
      },
      // rules: [{ message: this.$tc('warningTip.nameInvaild'), pattern: /^[\u4E00-\u9FA5]{1,50}$/, whitespace: true }],

      enName: {
        validateTrigger: 'blur',
        rules: [
          {
            whitespace: true,
            pattern: /^[a-zA-Z\s]{1,50}$/,
            message: this.$t('warningTip.enNameInvaild'),
          },
        ],
      },
      pinyinName: {
        validateTrigger: 'blur',
        rules: [
          {
            required: this.isName,
            whitespace: true,
            pattern: /^[a-zA-Z\s]{1,50}$/,
            message: this.$t('warningTip.pinyinNameInvaild'),
          },
        ],
      },
      idNumber: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            message: this.$t('warningTip.idNumberInvaild'),
            max: 50,
            min: 1,
            whitespace: true,
          },
        ],
      },
      address: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            max: 50,
            min: 1,
            whitespace: true,
            message: this.$t('warningTip.addressInvaild'),
          },
        ],
      },
      location: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            max: 50,
            min: 1,
            whitespace: true,
            message: this.$t('warningTip.addressInvaild'),
          },
        ],
      },
      schoolNowExtra: {
        rules: [
          {
            min: 1,
            max: 50,
            whitespace: true,
          },
        ],
      },
      mobile: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            message: this.$t('warningTip.mobileInvaild'),
            pattern: /^[0-9]+$/,
            whitespace: true,
          },
        ],
      },
      workUnit: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            message: this.$t('warningTip.workUnitInvaild'),
            max: 50,
            min: 1,
            whitespace: true,
          },
        ],
      },
      position: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            message: this.$t('warningTip.positionInvaild'),
            max: 50,
            min: 1,
            whitespace: true,
          },
        ],
      },
      email: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            message: this.$t('warningTip.emailInvaild'),
            type: 'email',
            whitespace: true,
          },
        ],
      },
      trimEmail: {
        validateTrigger: 'blur',
        rules: [
          {
            required: true,
            message: this.$t('warningTip.emailInvaild'),
            pattern: /^[ a-zA-Z0-9_.-]+@[ a-zA-Z0-9-]+(\.[ a-zA-Z0-9-]+)*\.[ a-zA-Z0-9]{2,6}$/,
            whitespace: true,
          },
        ],
      },
      remark: {
        validateTrigger: 'blur',
        rules: [
          {
            message: this.$t('warningTip.remarkInvaild'),
            whitespace: true,
          },
        ],
      },
      wxid: {
        rules: [
          {
            required: true,
            message: this.$t('warningTip.nameInvaild'),
            whitespace: true,
          },
        ],
      },
      graduatedFrom: {
        validateTrigger: 'blur',
        rules: [
          {
            message: this.$t('warningTip.schoolExtraInvaild'),
            max: 50,
            min: 1,
            whitespace: true,
          },
        ],
      },
      required: {
        rules: [
          {
            required: true,
            message: this.$t('pleaseSelect'),
          },
        ],
      },
      isKsRequired: {
        rules: [
          {
            required: this.config[this.school].isBoardingAndBusRequired,
            message: this.$t('pleaseSelect'),
          },
        ],
      },
      contentRequired: {
        rules: [
          {
            required: true,
            message: this.$t('warningTip.contentNotEmpty'),
          },
        ],
      },
    };
  }
  @Watch('userInfo', { immediate: false })
  public setSiblings() {
    if (!this.$route.query.draftId || !this.$route.query.studentId) {
      this.siblingInfoList = this.userInfo.siblings && this.userInfo.siblings.length > 0 ? this.userInfo.siblings : [];
      this.setDefaultSiblingList(this.siblingInfoList);
    }
  }
  @Watch('draftInfo', { immediate: false })
  public setFormDraftContent(): void {
    this.$nextTick(() => {
      this.draftId = this.draftInfo.draftId;
      this.studentId = this.draftInfo.studentId;
      this.applicationStep1Form.setFieldsValue(utils.formatDraftDataInStep1(this.draftInfo));
      const city = this.draftInfo.cityCode ? this.draftInfo.cityCode : undefined;
      const province = this.draftInfo.provinceCode ? this.draftInfo.provinceCode : undefined;
      const district = this.draftInfo.districtCode ? this.draftInfo.districtCode : undefined;
      this.location = [province, city, district];
      const domicileCity = this.draftInfo.domicileCity ? this.draftInfo.domicileCity : undefined;
      const domicileProvince = this.draftInfo.domicileProvince ? this.draftInfo.domicileProvince : undefined;
      const domicileDistrict = this.draftInfo.domicileDistrict ? this.draftInfo.domicileDistrict : undefined;
      this.censusLocation = [domicileProvince, domicileCity, domicileDistrict];
      this.siblingInfoList =
        this.draftInfo.siblings && this.draftInfo.siblings.length > 0 ? this.draftInfo.siblings : [];
      this.photoList = this.draftInfo.avatarUrlInfo ? [this.draftInfo.avatarUrlInfo] : [];
      this.IDList = this.draftInfo.idCards ? this.draftInfo.idCards : [];
      if (this.school === 'ks') {
        this.teacherSource = this.draftInfo.sourceId === 1280 ? true : false;
        this.studentSource = this.draftInfo.sourceId === 741 ? true : false;
      } else if (this.school === 'ts') {
        this.teacherSource = this.draftInfo.sourceId === 1326 ? true : false;
        this.studentSource = this.draftInfo.sourceId === 1325 ? true : false;
      } else {
        this.teacherSource = this.draftInfo.sourceId === 637 ? true : false;
        this.studentSource = this.draftInfo.sourceId === 1273 ? true : false;
      }

      this.$nextTick(() => {
        this.applicationStep1Form.setFieldsValue({
          sourceExtra: this.draftInfo.sourceExtra,
        });
      });
      this.setSiblingList(this.siblingInfoList);
      this.setAge(moment(this.draftInfo.birthday));
      if (!this.draftInfo.boarding) {
        if (this.draftInfo.birthday) {
          this.getRightSectionIdByBirthday(moment(this.draftInfo.birthday), this.draftInfo.schoolYearId);
          this.applicationStep1Form.setFieldsValue({
            boarding:
              this.draftInfo.boarding !== null ? (this.draftInfo.boarding === true ? 'true' : 'false') : undefined,
          });
          // boarding: this.draftInfo.boarding !== null ? (this.draftInfo.boarding === true ? 'true' : 'false') : undefined,
        }
      } else {
        this.applicationStep1Form.setFieldsValue({
          boarding:
            this.draftInfo.boarding !== null ? (this.draftInfo.boarding === true ? 'true' : 'false') : undefined,
        });
      }
      // this.boarding = this.draftInfo.boarding !== null ? (this.draftInfo.boarding === true ? 'true' : 'false') : '';
      // if (!this.draftInfo.boarding) {
      //   this.getRightSectionIdByBirthday(moment(this.draftInfo.birthday), this.draftInfo.schoolYearId);
      // } else {
      //   this.applicationStep1Form.setFieldsValue({
      //     boarding:
      //       this.draftInfo.boarding !== null ? (this.draftInfo.boarding === true ? 'true' : 'false') : undefined,
      //   });
      // }
    });
  }
  @Watch('enquiryData', { immediate: false })
  public setFormEnquiryContent(): void {
    this.$nextTick(() => {
      this.draftId = this.enquiryData.draftId;
      this.studentId = this.enquiryData.studentId;
      this.applicationStep1Form.setFieldsValue(utils.formatEnquiryDataInStep1(this.enquiryData));
      const city = this.enquiryData.cityCode ? this.enquiryData.cityCode : undefined;
      const province = this.enquiryData.provinceCode ? this.enquiryData.provinceCode : undefined;
      const district = this.enquiryData.districtCode ? this.enquiryData.districtCode : undefined;
      this.location = [province, city, district];
      const domicileCity = this.enquiryData.domicileCity ? this.enquiryData.domicileCity : undefined;
      const domicileProvince = this.enquiryData.domicileProvince ? this.enquiryData.domicileProvince : undefined;
      const domicileDistrict = this.enquiryData.domicileDistrict ? this.enquiryData.domicileDistrict : undefined;
      this.censusLocation = [domicileProvince, domicileCity, domicileDistrict];
      this.siblingInfoList =
        this.enquiryData.siblings && this.enquiryData.siblings.length > 0 ? this.enquiryData.siblings : [];
      this.photoList = this.enquiryData.avatarUrlInfo ? [this.enquiryData.avatarUrlInfo] : [];
      this.IDList = this.enquiryData.idCards ? this.enquiryData.idCards : [];
      this.setSiblingList(this.siblingInfoList);
      this.setAge(moment(this.enquiryData.birthday));
      if (this.enquiryData && this.enquiryData.sourceId && this.$route.query.studentId) {
        this.isSource = true;
      } else {
        this.isSource = false;
      }
      if (!this.enquiryData.boarding) {
        if (this.enquiryData.birthday) {
          this.getRightSectionIdByBirthday(moment(this.enquiryData.birthday), this.enquiryData.schoolYearId);
          this.$nextTick(() => {
            this.applicationStep1Form.setFieldsValue({
              boarding:
                this.enquiryData.boarding !== null
                  ? this.enquiryData.boarding === true
                    ? 'true'
                    : 'false'
                  : undefined,
            });
          });
        }
      } else {
        this.$nextTick(() => {
          this.applicationStep1Form.setFieldsValue({
            boarding:
              this.enquiryData.boarding !== null ? (this.enquiryData.boarding === true ? 'true' : 'false') : undefined,
          });
        });
      }
    });
  }
  public checkCountryAndName(values: any): boolean {
    let flag = false;
    if ([1, 86, 114, 190].includes(values.countryId)) {
      if (!values.name || (this.config[this.school].isChineseEnNameRequired && !values.enName)) {
        flag = true;
      }
    }
    return flag;
  }

  public getStep1FormInfo(e: any): any {
    e.preventDefault();
    this.applicationStep1Form.validateFieldsAndScroll((err: any, values: any) => {
      if (!err) {
        if (!this.checkSiblings()) {
          this.$message.error(this.$tc('applicationForm.checkSibling'));
        } else if (!values.name && !values.enName) {
          this.$message.error(this.$tc('applicationForm.tip1'));
        } else if (this.checkCountryAndName(values)) {
          this.$message.error(this.$tc('applicationForm.tip5'));
        } else if (!(this.$refs.address as LocationCascader).checkAddress()) {
          this.$message.error(this.$tc('applicationForm.checkAddress'));
        } else if (this.config[this.school].censusRequired && !(this.$refs.census as LocationCascader).checkAddress()) {
          this.$message.error(this.$tc('applicationForm.checkAddress2'));
        } else if (!this.config[this.school].formFileNotReqiured && !this.photoList.length) {
          this.$message.error(this.$tc('applicationForm.photoIsRequired'));
        } else if (!this.config[this.school].formFileNotReqiured && !this.IDList.length) {
          this.$message.error(this.$tc('applicationForm.IDIsRequired'));
        } else if (this.isStudentExist) {
          this.$message.error(this.$tc('applicationForm.studentExist'));
        } else {
          values.siblings = this.siblingInfoList;
          values.provinceCode = this.location[0];
          values.cityCode = this.location[1];
          values.districtCode = this.location[2];
          values.domicileProvince = this.censusLocation[0];
          values.domicileCity = this.censusLocation[1];
          values.domicileDistrict = this.censusLocation[2];
          values.avatarUrlInfo = this.photoList.length > 0 ? this.photoList[0] : undefined;
          values.idCards = this.IDList;
          values.semesterId = values.schoolYearId[1];
          values.schoolYearId = values.schoolYearId[0];
          values.sourceExtraId = this.sourceExtraId;
          this.$emit('changeStep', 'next', 'step1', values);
        }
      }
    });
  }

  public checkSiblings(): boolean {
    let flag = true;
    if (this.isHasSibling === '') {
      flag = false;
    } else {
      this.siblingInfoList.forEach((item: any) => {
        if (
          !item.siblingStudentId &&
          (!item.name || item.gender === undefined || !item.birthday || !item.schoolNowExtra)
        ) {
          flag = false;
        }
      });
    }
    return flag;
  }

  public getDraftContent(e: any): any {
    e.preventDefault();
    const values = this.applicationStep1Form.getFieldsValue();
    const data: any = {
      ...values,
      schoolYearId: values.schoolYearId ? values.schoolYearId[0] : null,
      semesterId: values.schoolYearId ? values.schoolYearId[1] : null,
      provinceCode: this.location[0] ? this.location[0] : null,
      cityCode: this.location[1] ? this.location[1] : null,
      districtCode: this.location[2] ? this.location[2] : null,
      domicileProvince: this.censusLocation[0] ? this.censusLocation[0] : null,
      domicileCity: this.censusLocation[1] ? this.censusLocation[1] : null,
      domicileDistrict: this.censusLocation[2] ? this.censusLocation[2] : null,
      siblingDrafts: this.siblingInfoList,
      avatarUrlInfo: this.photoList && this.photoList.length > 0 ? this.photoList[0] : undefined,
      idCards: this.IDList,
      studentId: this.studentId,
      draftId: this.draftId,
      sourceExtraId: this.sourceExtraId,
    };

    let parentInfo: any = {};
    parentInfo = JSON.stringify(this.step2Info) === '{}' ? this.userInfo : this.step2Info;
    data.parentDraftInfo = parentInfo;
    if (JSON.stringify(this.step2Info) !== '{}') {
      data.parentDraftInfo.guardianDraftRequest = parentInfo.guardianMobile
        ? utils.formatGuardianData(parentInfo)
        : null;
      data.parentDraftInfo.emergencyContactDraftRequest =
        parentInfo.emergencyContactFlag === 'false' ? utils.formatEmergencyData(parentInfo) : null;
    } else {
      data.parentDraftInfo.guardianDraftRequest = this.userInfo.guardianResponse;
      data.parentDraftInfo.emergencyContactDraftRequest = this.userInfo.emergencyContactResponse;
    }
    return data;
  }

  public saveToDraft(e: Event): void {
    this.$emit('saveToDraft', true);
    const request = this.getDraftContent(e);
    if (!(request.name || request.enName) || !request.gender) {
      this.$message.error(this.$tc('applicationForm.draftTip'));
    } else {
      KunshanApplicationController.addDraft(request).then(() => {
        this.$message.success(this.$tc('applicationForm.successSave'));
        this.$router.push({ name: 'home' });
      });
    }
  }
}
